import { Container, Eyebrow } from "@constructorfleet/ui/design-system";

export function PrivacyPolicyPage() {
  return (
    <div className="policy-page">
      <section className="ph">
        <Container>
          <Eyebrow brand dot>
            Legal
          </Eyebrow>
          <h1>Privacy Policy</h1>
          <p className="lede">Last updated March 2026</p>
        </Container>
      </section>

      <section className="policy-body">
        <Container small>
          <section className="policy-section">
            <h2>Scope</h2>
            <p>
              This Privacy Policy explains how ConstructorFleet collects, uses, shares, retains, and
              protects personal information when you use our services. The service is intended only
              for users in the United States.
            </p>
          </section>

          <section className="policy-section">
            <h2>Independent Service</h2>
            <p>
              ConstructorFleet operates solely as a tool for individual users and does not act on
              behalf of any clinic, provider, or treatment program. ConstructorFleet does not
              provide medical, clinical, or healthcare services. All data processed by
              ConstructorFleet is collected at the direction of the user and is not received from or
              maintained on behalf of any healthcare provider. ConstructorFleet is not affiliated
              with or endorsed by any clinic, provider, or treatment program, including BHG.
            </p>
          </section>

          <section className="policy-section">
            <h2>What We Collect</h2>
            <p>
              We collect the information needed to operate the service you select. Depending on the
              product and features you enable, this may include your name, username, email address,
              mobile phone number, billing records, product-specific identifiers, call metadata,
              call transcripts, call recordings where enabled or available, schedule and result data
              derived from IVR interactions, API access credentials, and webhook delivery logs.
            </p>
          </section>

          <section className="policy-section">
            <h2>How We Use Your Data</h2>
            <p>
              We use personal information to authenticate your account, deliver the services you
              request, place and analyze automated calls, determine schedules from IVR responses,
              send service-related communications, process payments, secure the platform,
              investigate misuse, and improve reliability.
            </p>
          </section>

          <section className="policy-section">
            <h2>Service Providers &amp; Sharing</h2>
            <p>
              We do not sell your personal information. Mobile opt-in data, consent records, and
              phone numbers collected for SMS communications are not shared with third parties or
              affiliates for their own marketing or promotional purposes. We may share information
              with service providers that help us operate the platform, including telephony,
              messaging, and transcription vendors, error monitoring providers, hosting and
              infrastructure providers, and payment processors we select. These providers may change
              over time. We currently support telephony providers such as Twilio and Telnyx, and may
              use a third-party or self-hosted error monitoring solution.
            </p>
          </section>

          <section className="policy-section">
            <h2>SMS Communications</h2>
            <p>
              If you provide your mobile phone number and enable SMS notifications in your account
              settings, ConstructorFleet may send you non-promotional text messages related to your
              account and service use. These may include password reset codes, account security
              alerts, and product-specific operational notifications such as BHG Check-in Assist
              schedule updates and status notifications. Message frequency varies based on your
              account activity and enabled features. Message and data rates may apply. You may opt
              out of SMS at any time by replying STOP. For help, reply HELP or contact support at{" "}
              <a href="mailto:support@constructorfleet.com">support@constructorfleet.com</a>.
            </p>
          </section>

          <section className="policy-section">
            <h2>Retention</h2>
            <p>
              We retain information for as long as needed to provide the service, comply with legal
              obligations, resolve disputes, and enforce our agreements. Account records, call
              history, and transcripts may remain available while your account is active and for a
              reasonable period after cancellation. Default recording retention is shorter than
              transcript retention and may be extended if you enable features such as Extended Audio
              Storage.
            </p>
            <p>
              If a recording retention feature is enabled, Extended Audio Storage may keep call
              recordings for a longer period than the default retention window.
            </p>
          </section>

          <section className="policy-section">
            <h2>Your Choices &amp; Rights</h2>
            <p>
              You may request access, correction, export, or deletion of personal information we
              maintain about you, subject to legal and operational limits. You may also update
              account details, notification preferences, and certain product settings from your
              dashboard.
            </p>
          </section>

          <section className="policy-section">
            <h2>How We Protect Your Data</h2>
            <p>
              We use administrative, technical, and organizational safeguards designed to protect
              personal information. This includes encryption in transit and encryption at rest for
              sensitive stored data. We also use logging, access controls, and monitoring to
              maintain system security.
            </p>
          </section>

          <section className="policy-section">
            <h2>Monitoring &amp; Diagnostics</h2>
            <p>
              We may collect technical diagnostics such as application errors, timestamps, request
              context, and device or browser metadata to detect outages, investigate bugs, and
              maintain service reliability.
            </p>
          </section>

          <section className="policy-section">
            <h2>Children&apos;s Privacy</h2>
            <p>
              ConstructorFleet is not directed to children under 13, and we do not knowingly collect
              personal information from children under 13.
            </p>
          </section>

          <section className="policy-section">
            <h2>Contact</h2>
            <p>
              Questions or requests about this policy may be sent to{" "}
              <a href="mailto:support@constructorfleet.com?subject=Privacy%20Policy%20Inquiry">
                support@constructorfleet.com
              </a>
              .
            </p>
          </section>
        </Container>
      </section>
    </div>
  );
}
